import { Sparkles, RefreshCcw, Lock } from "lucide-react";
import { ORDER_BREAKDOWN } from "@/constants/testIds/pricing";

const euro = (n) => {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return "—";
  return `€ ${Number(n).toFixed(2).replace(".", ",")}`;
};

export default function OrderBreakdown({ pricing, quantity, showLockStatus = false, compact = false }) {
  if (!pricing) return null;
  const isReorder = pricing.order_type === "reorder";
  const OrderIcon = isReorder ? RefreshCcw : Sparkles;
  const pillClass = isReorder
    ? "bg-[#5B7CFB]/12 text-[#4560D8]"
    : "bg-[#00F2F4]/12 text-[#00D6D8]";

  return (
    <div
      data-testid={ORDER_BREAKDOWN.container}
      className={`rounded-xl border border-[var(--border-c)] bg-[var(--bg-3)]/40 ${compact ? "p-4" : "p-5"}`}
    >
      <div className="flex items-center justify-between gap-3 mb-3">
        <div className="flex items-center gap-2">
          <span
            data-testid={ORDER_BREAKDOWN.orderType}
            className={`inline-flex items-center gap-1.5 text-[10px] font-sans font-semibold uppercase tracking-[0.15em] px-3 py-1 rounded-full ${pillClass}`}
          >
            <OrderIcon size={11} strokeWidth={2} />
            {isReorder ? "Riordino" : "Primo ordine"}
          </span>
          {showLockStatus && pricing.locked && (
            <span className="inline-flex items-center gap-1 text-[10px] uppercase tracking-[0.15em] text-[var(--fg-3)] font-sans">
              <Lock size={10} /> Prezzo bloccato
            </span>
          )}
        </div>
      </div>

      <dl className="space-y-2 text-sm">
        <div className="flex justify-between items-center">
          <dt className="text-[var(--fg-3)]">Quantità</dt>
          <dd className="text-[var(--fg-1)] font-mono">{quantity} card</dd>
        </div>
        <div className="flex justify-between items-center">
          <dt className="text-[var(--fg-3)]">Prezzo unitario</dt>
          <dd data-testid={ORDER_BREAKDOWN.unitPrice} className="text-[var(--fg-1)] font-mono">
            {euro(pricing.unit_price)}
          </dd>
        </div>
        <div className="flex justify-between items-center">
          <dt className="text-[var(--fg-3)]">Subtotale</dt>
          <dd data-testid={ORDER_BREAKDOWN.subtotal} className="text-[var(--fg-1)] font-mono">
            {euro(pricing.subtotal)}
          </dd>
        </div>
        <div className="flex justify-between items-center">
          <dt className="text-[var(--fg-3)]">Spedizione</dt>
          <dd data-testid={ORDER_BREAKDOWN.shipping} className="text-[var(--fg-1)] font-mono">
            {euro(pricing.shipping_cost)}
          </dd>
        </div>
        <div className="pt-2 mt-2 border-t border-[var(--border-c)] flex justify-between items-center">
          <dt className="text-[var(--fg-1)] font-serif text-base">Totale</dt>
          <dd
            data-testid={ORDER_BREAKDOWN.total}
            className="text-[var(--fg-1)] font-serif text-xl"
          >
            {euro(pricing.total)}
          </dd>
        </div>
      </dl>
    </div>
  );
}
